<tec-list-layout>
	<tec-title-group [title]="'WORKFLOWS.TITLE' | translate">
		@if (rolePermissions.canCreateWorkflow()) {
			<tec-button [label]="'BUTTON.CREATE' | translate" (clickEvent)="openModalCreate($event)" />
		}
	</tec-title-group>

	<ng-container content>
		<!-- ERROR  -->
		@if(alertError)  {
			<tec-alert
				status="error"
				[msg]="alertError"
				(closeAlert)="alertError = ''"
			></tec-alert>
		}
		<tec-table-filter [selection]="{all: false, ids: []}">
			<tec-toolbar
				[toolbar]="toolbar()"
				[maxFilter]="4"
				(formFilter)="filterChange($event)"
				(actionClick)="onToolbarAction($event)"
			></tec-toolbar>
			<tec-table
				[headers]="header"
				[rows]="content"
				[config]="config"
				(sortEvent)="sortChange($event)"
				(cellEvent)="tableCell($event)"
				(rowEvent)="tableRow($event)"
				(paginationChange)="paginationChange($event)"
			></tec-table>
		</tec-table-filter>
	</ng-container>
</tec-list-layout>

@if (workflow) {
	<app-modal-create-process [workflow]="workflow" (closeEvent)="workflow = undefined"></app-modal-create-process>
}

@if (showModalCreate && rolePermissions.canViewWorkflowJson()) {
	<app-modal-workflow-form (closeEvent)="closeModalCreate($event)"/>
}

@if (showModalJsonCreate && rolePermissions.canViewWorkflowJson()) {
	<app-modal-workflow-json-editor (closeEvent)="closeModalJsonCreate($event)"/>
}

@if (showModalDuplicate) {
	<app-modal-workflow-duplicate (closeEvent)="closeModalDuplicate($event)"/>
}

@if (workflowToDuplicateToEnv) {
	<app-modal-workflow-duplicate-to-env
		[workflow]="workflowToDuplicateToEnv"
		(closeEvent)="closeModalDuplicateToEnv($event)"
	/>
}

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_WORKFLOWS_LIST'"
		[curlText]="getWorkflowsListCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
